import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { Caller } from '../../_models/caller';
import { User } from '../../_models/user';
import { Globals } from '../../_models/globals';
import { AccessSecurity } from '../../_models/accessSecurity';
import { AlertService } from '../../_services/alert.service';

@Component({
  selector: 'app-authorize',
  templateUrl: './authorize.component.html',
  styleUrls: ['./authorize.component.scss'],
})

export class AuthorizeComponent implements OnInit {
  @ViewChild('pwd', { static: false }) pwd: ElementRef;
  userEmail: string = "";
  userPwd: string = "";
  errorMessage: string = "";
  errorEmail: string = "";
  statusText1: string;
  statusText2: string;
  showPassword: boolean = false;
  encodedKey: string;
  provider: string;
  clickBox: any;
  access: any;
  clickBoxError: string;

  codeValue: string;
  providerValue: string;
  redirectUrlValue: string;
  stateValue: string;

  constructor(private alertService: AlertService, public http: HttpClient, private router: Router, public route: ActivatedRoute, public caller: Caller, public user: User, public g: Globals, public accessSec: AccessSecurity) {

    this.codeValue = this.g.code;
    this.providerValue = this.g.provider;
    this.redirectUrlValue = this.g.redirectUrl;
    this.stateValue = this.g.state;
    this.access = ['Inbound Orders', 'Address Book', 'Outbound Orders', 'Invoices', 'Products', 'Work Orders'];

  }

  ngOnInit() {
    console.log("Inside Authorize");
    try {
      /*     this.route.queryParams
              .subscribe(params => {
                this.codeValue = params.code;
                this.providerValue = params.provider;
                this.redirectUrlValue = params.redirectUrl;
                this.stateValue = params.state;
                console.log('Code::' + this.codeValue);
                console.log('providerValue::' + this.providerValue);
                console.log('redirectUrlValue::' + this.redirectUrlValue);
                console.log('stateValue::' + this.stateValue);
              }); */
      var elements = document.getElementsByClassName('login-section3');
      elements[0].classList.remove("login-section3");
      var img = document.getElementsByClassName('logo-section');
      img[0].classList.remove("login-section3");
    } catch (e) {
      console.log("Exception in Authorize");
    }
  }

  submitAuthorize() {
    this.clickBoxError = "";
    if (!this.clickBox) {
      this.clickBoxError = "Please acknowledge terms and conditions";
      return false
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/authorizeUserAndKey', {
      "encodedKey": this.codeValue,
      "provider": this.providerValue
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Success', data['message']);
          let url = data['redirectUrl'] + "?secretKey=" + data['secretKey'] + "&state=" + this.stateValue;
          //this.router.navigate([url]);
          window.location.href = url;
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }
}
